/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Book_Button_OnInputs */

const fr_label_book_button_on = /** @type {(inputs: Label_Book_Button_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiché`)
};

const en_label_book_button_on = /** @type {(inputs: Label_Book_Button_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown`)
};

/**
* | output |
* | --- |
* | "Shown" |
*
* @param {Label_Book_Button_OnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_book_button_on = /** @type {((inputs?: Label_Book_Button_OnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Book_Button_OnInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_book_button_on(inputs)
	return en_label_book_button_on(inputs)
});